import { Badge } from '@material-ui/core';
import { fill } from '../../utils/contrastSvgAttributes';
import DisabledIcon from '@mui/icons-material/HideSource';
import { useStyles } from './DisabledBadge.styles';

interface DisabledBadgeProps {
  badgeHidden?: boolean;
  transform?: { left: string; top: string };
  width?: string;
  height?: string;
}

const DisabledBadge: React.FC<DisabledBadgeProps> = (props) => {
  const classes = useStyles();
  return (
    <Badge
      className={classes.container}
      overlap="rectangular"
      badgeContent={
        <DisabledIcon
          fontSize="small"
          style={{
            fill: fill,
            width: props?.width ?? '16px',
            height: props?.height ?? '16px',
            position: 'relative',
            left: props.transform?.left ?? '-11px',
            top: props.transform?.top ?? '11px',
            cursor: 'not-allowed',
            zIndex: 10,
          }}
        />
      }
      invisible={props.badgeHidden}
    >
      {props.children}
    </Badge>
  );
};
export default DisabledBadge;
